<template>
  <div class="main">
    <div class="steps clearfix text-center">
      <Logo />
    </div>
    <div class="container">
      <h2>create an online account</h2>
      <p class="text-center">
        Do you need any help?&nbsp;<a
          href=""
          data-target="#helpModal"
          data-toggle="modal"
          >Get in touch
        </a>
      </p>
      <div class="signup-form wizard clearfix pt-0">
        <form
          method="POST"
          id="signup-form"
          novalidate="novalidate"
          autocomplete="off"
          @submit.prevent="signup()"
        >
          <div class="steps clearfix text-center">
            <img src="/assets/img/icons8-lock-100.png" />
          </div>
          <div class="content clearfix">
            <div class="row" v-if="!selectAccountType">
              <!-- <div class="col-sm-12">
                <h4 class="info-text ">
                  Let's get started
                </h4>
              </div> -->
              <div class="col-sm-12">
                <div class="form-group">
                  <label class="form-label required">Email</label>
                  <input
                    name="email"
                    type="email"
                    class="form-control"
                    :class="{ error: errors.has('step1.email') }"
                    placeholder="Email Address"
                    v-model.trim="email"
                    data-vv-scope="step1"
                    v-validate="'required|email'"
                  />
                </div>
              </div>

              <div class="col-sm-12">
                <message-info />
              </div>
              <div class="col-sm-12 mt-3">
                <input
                  type="button"
                  class="btn btn-fill btn-success btn-block btn-wd btn-md"
                  name="save"
                  value="Sign up"
                  @click.prevent="signup()"
                />
              </div>
              <div class="col-sm-12 mt-2">
                <hr />
                <privacy-policy />
              </div>
            </div>
            <account-type v-else />
          </div>
        </form>
        <Loading v-if="loading" />
      </div>
    </div>
  </div>
</template>
<script>
import Logo from "@/components/ui/Logo.vue";
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import mixin from "@/components/shared/mixinUtility";
import axios from "axios";
import MessageInfo from "@/components/ui/MessageInfo.vue";
import AccountType from "@/components/ui/AccountType.vue";
import Loading from "@/components/ui/Loading.vue";
import PrivacyPolicy from '@/components/ui/PrivacyPolicy.vue';
export default {
  name: "OnlineAccess",
  mixins: [mixin],
  data() {
    return {
      loading: false,
      existingClientsToContactSmart: [213, 214, 215, 218, 220],
      selectAccountType: false,
      contactUs:
        'We\'ve encountered a problem.<br>Please <a href="mailto:onboarding@smartcurrencyexchange.com">email us</a> or give us a call on <a href="tel:+442078980541">+44 20 7898 0541</a>',
    };
  },
  computed: {
    ...mapFields(["form.email"]),
    ...mapGetters({
      formData: "getFormData",
      contactId: "getContactId",
    }),
  },
  methods: {
    signup() {
      this.resetMessageInfo();
      this.$root.$validator.validate("step1.*").then(async (valid) => {
        if (valid) {
          try {
            this.loading = true;
            const data = await this.checkOnlineAccess();
            this.loading = false;
            const clientStatusId = data.data.StatusId;

            if (
              this.existingClientsToContactSmart.find(
                (ex) => ex == clientStatusId
              )
            ) {
              //show contact SMart message
              this.showGenericErrorMessage(this.contactUs, false);
            } else {
              this.$store.dispatch(
                "isPrivateClient",
                data.data.ContactType == "PC"
              );
              if (clientStatusId == 210) {
                //new client
                //ask if they want corp or private application form
                this.selectAccountType = true;
              } else if (clientStatusId == 211) {
                //Based on Contact Type direct to relevant Application Form
                //redirect to application form based on contacType
                if (data.data.ContactType == "PC") {
                  //Private
                  //set contactId
                  this.$store.dispatch("setContactId", data.data.ContactId);
                  this.$store.dispatch("setContactExist", true);
                  //redirect to application form
                  this.$router.push({ name: "Home" });
                } else {
                  //business client
                  //redirect to application SCB form
                  window.location.href =
                    "https://www.smartcurrencybusiness.com/open-an-account/";
                }
              } else if (clientStatusId == 212) {
                //If Contact Type is Corp Then ask to Contact Smart ELSE Take to Private Application Form
                if (data.data.ContactType == "PC") {
                  //Private
                  //set contactId
                  this.$store.dispatch("setContactId", data.data.ContactId);
                  this.$store.dispatch("setContactExist", true);
                  //redirect to application form
                  this.$router.push({ name: "Home" });
                } else {
                  //corp account- contact smart
                  //show contact SMart message
                  this.showGenericErrorMessage(this.contactUs, false);
                }
              } else if (clientStatusId == 216) {
                //IF CORP Then ask to Login to Online Portal Else Login to Online Portal / download SMT App
                //redirect to thank you/success page
                if (data.data.ContactType == "PC")
                  this.$router.push({ name: "Success" });
                else
                  this.$router.push({
                    name: "Success",
                    params: { isCorporate: true },
                  });
              } else if (clientStatusId == 217) {
                //check if they got a valid or any mobile number
                if (
                  data.data.MobileNumber == null ||
                  data.data.MobileNumber == ""
                ) {
                  //show contact SMart message
                  this.showGenericErrorMessage(this.contactUs, false);
                } else {
                  //Proceed with First Time Login process
                  //set contactId
                  await this.$store.dispatch("setContactId", data.data.ContactId);
                  await this.$store.dispatch("setContactExist", true);
                  //generate token first
                  this.loading = true;
                 const token = await this.generateToken(data.data.ContactId);
                  this.loading = false;
                  //redirect to first time login
                  this.$router.push({
                    name: "FirstLogin",
                    params: { tokenvalue: token },
                  });
                }
              }
            }
          } catch (ex) {
            this.showGenericErrorMessage("We've encountered a problem. " + ex, false);
            this.loading = false;
          }
          //all valid?
        } else {
          //not valid
          this.showGenericErrorMessage(
            "Please enter all mandatory fields.",
            false
          );
        }
      });
    },
    async checkOnlineAccess() {
      const { data } = await axios.get(
        process.env.VUE_APP_API_URL +
          "/client/CheckOnlineAccess?email=" +
          this.formData.email +
          "&bizID=22"
      );

      return data;
    },
  },
  components: {
    "message-info": MessageInfo,
    "account-type": AccountType,
    Logo,
    Loading,
      "privacy-policy": PrivacyPolicy,
  },
  created() {
    this.resetMessageInfo();
  },
};
</script>
